import React from "react";
import "./Home.css";
export default function Home() {
  return (
    <div className="home-content">
      <div className="shape"></div>
      <p className="home-text">
        {/* I am Merisa Besirovic, frontend developer based in Novi Pazar, Serbia.
        Passionate about creating engaging user experiences and crafting
        beautiful websites. Let's build something incredible together! */}
        I am Merisa Besirovic, software engineering student at State University
        at Novi Pazar, based in Serbia. Passionate about creating engaging user
        experiences. Let's build something incredible together!
      </p>
    </div>
  );
}
